/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 12/17/2024
 */
import React, { useState, useEffect } from "react"
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
} from "@mui/material"
import QRCode from "react-qr-code"

const QrCodeModal = ({ open, onClose, orgCode, groupId }) => {
  const [inputValues, setInputValues] = useState({})
  useEffect(() => {
    setInputValues(`{orgCode:${orgCode},groupId:${groupId}}`)
  }, [groupId])
  return (
    <div>
      <Dialog
        fullWidth
        maxWidth="xs"
        open={open}
        PaperProps={{ style: { borderRadius: "10px" } }}
      >
        <DialogTitle sx={{ bgcolor: "#116c6f", color: "white" }}>
          Group QR Code
        </DialogTitle>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          dividers
        >
          <div>
            {inputValues && (
              <QRCode title="GeeksForGeeks" value={inputValues} />
            )}
          </div>
        </DialogContent>

        <DialogActions sx={{ p: "1.25rem" }}>
          <Button onClick={onClose} variant="outlined" color="error">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default QrCodeModal
